import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@sm/wds-react';
import { t, defineMessages } from '@sm/intl';
import { useSurveyTheme, createSurveyStyles } from '@sm/webassets';
import { generateMetricsAttribute } from '@sm/metrics';
import checkDarkMode from '~app/helpers/luminance';
import './action-group.scss';

const DEFAULT_COPY = defineMessages({
  DONE: {
    id: 'ActionGroup.Done',
    defaultMessage: 'Done',
    description: '[Type: Button][Vis.: low] - Done button',
  },
});

const useStyles = createSurveyStyles(theme => {
  return {
    actionGroupColor: {
      color: theme?.secondaryAccentColor,
      borderColor: theme?.primaryAccentColor,
      backgroundColor: theme?.primaryAccentColor,
    },
    actionGroupButton: {
      extend: 'actionGroupColor',
      fontFamily: theme?.questionBody?.fontFamily,
      transition: 'all 0.2s linear',
      '&:hover': {
        extend: 'actionGroupColor',
        boxShadow: `0 0 4px ${theme?.primaryAccentColor}`,
        outlineOffset: '5px',
        outline: `1px solid ${theme?.primaryAccentColor}`,
      },
    },
  };
});

const ActionGroup = ({ qrDoneUrl }) => {
  const theme = useSurveyTheme();
  const { actionGroupButton } = useStyles();
  const backgroundColor = theme.primaryBackgroundColor || '#fff';
  const acBtnColor = checkDarkMode(backgroundColor) ? 'black' : 'primary';

  return (
    <div className="sm-action-group--container">
      <div className="sm-action-group--cta">
        <Button
          data-testid="ActionGroup__QuizDone"
          className={actionGroupButton}
          size="lg"
          color={acBtnColor}
          href={qrDoneUrl}
          data-sm-metrics={generateMetricsAttribute({
            data: {
              actionFlow: 'smwebQuizResultsDoneBtn',
              actionType: 'quiz_results_done',
              button: 'quiz_results_done',
              uiTrigger: 'quiz_results_done_btn',
              log: {
                level: 'info',
                message: 'smweb quiz results done button clicked',
              },
            },
          })}
        >
          {t(DEFAULT_COPY.DONE)}
        </Button>
      </div>
    </div>
  );
};

ActionGroup.propTypes = {
  qrDoneUrl: PropTypes.string,
};

ActionGroup.defaultProps = {
  qrDoneUrl: '/',
};

export default ActionGroup;
